var jwtDecode = require('jwt-decode');
import customLocalStorage from '@/config/customLocalStorage';
import { TokenOpts } from '@/models/authentication/authResultModel';
import customJSON from '@/config/customJSON';

export enum Actions {
  addCreditCard,
  administrating,
  amenities,
  approveOrders,
  badges,
  book,
  enroll,
  listing,
  location,
  login,
  logout,
  policyAndProcedures,
  programStatement,
  propertyAndGuest,
  seeClickbait,
  seeHomeProviderPlaceholder,
  setUpProfile,
  switchToParent,
  switchToProvider,
  toggleSidebar,
  viewUsers,
}

export enum Roles {
  HomeProvider,
  Parent,
  SuperAdmin,
  Nanny
}

export class UserPermissions {
  private static superAdminActions = [
    Actions.login,
    Actions.logout,
    Actions.administrating,
    Actions.enroll,
    Actions.addCreditCard,
    Actions.seeClickbait,
    Actions.setUpProfile,
    Actions.toggleSidebar,
    Actions.seeHomeProviderPlaceholder,
    Actions.listing,
    Actions.book,
    Actions.viewUsers
  ];

  private static parentActions = [
    Actions.login,
    Actions.logout,
    Actions.enroll,
    Actions.addCreditCard,
    Actions.seeClickbait,
    Actions.setUpProfile,
    Actions.toggleSidebar,
    Actions.switchToProvider,
    Actions.book
  ]

  private static nannyActions = [
    Actions.login,
    Actions.logout,
    Actions.enroll,
    Actions.addCreditCard,
    Actions.seeClickbait,
    Actions.setUpProfile,
    Actions.toggleSidebar,
    Actions.switchToProvider
  ]

  private static homeProviderActions = [
    Actions.login,
    Actions.logout,
    Actions.seeHomeProviderPlaceholder,
    Actions.toggleSidebar,
    Actions.propertyAndGuest,
    Actions.programStatement,
    Actions.badges,
    Actions.amenities,
    Actions.location,
    Actions.policyAndProcedures,
    Actions.switchToParent,
    Actions.listing,
    Actions.toggleSidebar,
    Actions.approveOrders
  ]

  private static getAssignedActions() {
    const currRole: Number = UserPermissions.getCurrentRole();

    switch (currRole) {
      case Roles.HomeProvider:
        return UserPermissions.homeProviderActions;
      case Roles.Parent:
        return UserPermissions.parentActions;
      case Roles.SuperAdmin:
        return UserPermissions.superAdminActions;
      case Roles.Nanny:
        return UserPermissions.nannyActions;
    }

    return null;
  }

  private static getTokenClaim(name: string) {
    const tokenStr: string | null = customLocalStorage.getItem("token") as string;
    const token: TokenOpts | null = customJSON.parse(tokenStr, true);

    if (!token) {
      return null;
    }

    const decodedToken = jwtDecode(token.accessToken);

    return decodedToken[name];
  }

  public static autoLoginRole(): string | null {
    let res: string = this.getTokenClaim("autoLoginRole");

    return(res);
  }

  public static autoLoginUrl(): string | null {
    let res: string = this.getTokenClaim("autoLoginUrl");

    return(res);
  }

  public static isTemporary(): boolean | null {
    let res: boolean = false;
    
    const isTemporary: string = this.getTokenClaim("isTemporary");

    if ((isTemporary) && (isTemporary.toLowerCase() === 'true')) {
      res = true;
    }

    return(res);
  }

  public static enrolledChildren(): boolean | null {
    let childrenCount: number = this.getTokenClaim("children");

    return childrenCount > 0;
  }

  public static addedCreditCard(): boolean | null {
    const childrenCount: number = this.getTokenClaim("creditCards") as number;

    return childrenCount > 0;
  }

  public static completedRegisterInfo(): boolean | null {
    const completedRegisterInfo = this.getTokenClaim("supplementedInfo");

    return completedRegisterInfo === "true";
  }

  public static getCurrentRole(): Number {
    const currRole: any = this.getTokenClaim("http://schemas.microsoft.com/ws/2008/06/identity/claims/role");

    if (!currRole) {
      return -1;
    }

    const roleNum = Number.parseInt(Roles[currRole]);

    return roleNum;
  }

  public static getCurrentEmail(): string | null {
    const currEmail: string = this.getTokenClaim("email");

    return currEmail;
  }

  public static getNumberInQueue(): Number {
    let res: Number = 0;

    const numberInQueue: string = this.getTokenClaim("numberInQueue");

    res = Number.parseInt(numberInQueue);

    return(res);
  }

  public static can = (action: Actions) => {
    const currUserActions = UserPermissions.getAssignedActions();
    const availableAction = currUserActions?.find(a => a === action);

    return availableAction != null;
  }

	public static logout = (dispatch: any, router: any, nextRouterPath: any) => {
    dispatch('auth/logout')
    .then(
      (data: any) => {
        if (nextRouterPath) {
          router.push(nextRouterPath);
        }
        else {
          router.push('/entry/login');
        }
      },
      (error: any) => {
        const errMsg = error.response.data;
      }
    )
    .catch((error: any) => console.log(error));
  }  
}